import { useIsCurrentUserRestricted } from '@ms/yammer-hooks/dist/session/selectors';
import { useLeadershipCornerBanner } from '@ms/yammer-web-components/dist/leadershipCorner/LeadershipCornerBanner';
import RestrictedUserBanner from '@ms/yammer-web-components/dist/user/RestrictedUserBanner';
import Flex, { FlexItem } from '@ms/yammer-web-core-ui/dist/components/Flex';
import React, { useMemo } from 'react';

export const useGetBanners = () => {
  const leadershipCornerBanner = useLeadershipCornerBanner();
  const shouldShowRestrictedUserBanner = useIsCurrentUserRestricted();

  return useMemo(() => {
    const leadershipCornerBannerContent = leadershipCornerBanner ? <FlexItem>{leadershipCornerBanner}</FlexItem> : null;
    const restrictedUserBannerContent = shouldShowRestrictedUserBanner ? (
      <FlexItem>
        <RestrictedUserBanner />
      </FlexItem>
    ) : null;

    const hasAnyBanner = leadershipCornerBanner || shouldShowRestrictedUserBanner;

    const renderContent = hasAnyBanner ? (
      <Flex grow={1} direction="column">
        {leadershipCornerBannerContent}
        {restrictedUserBannerContent}
      </Flex>
    ) : null;

    return renderContent;
  }, [leadershipCornerBanner, shouldShowRestrictedUserBanner]);
};
